module.exports = "<div class=flight-advanced-options><div class=first-section><div ng-include=\"'app/modules/base/templates/flights/form_options/cabin_class_dropdown.tmpl.html'\"></div></div><div><ol class=options-list><li class=item-check><checkbox aria-label=\"{{l10n.localize('Direct flights only')}}\" role=checkbox class=\"styled_checkbox top-level\" id=DirectFlightsOnly ng-model=params.DirectFlightsOnly></checkbox><label class=elem-label for=DirectFlightsOnly><l10n>Direct flights only</l10n></label></li></ol></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/directives/templates/moreOptions.tmpl.html
// module id = 3695
// module chunks = 0